"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptsReportType = exports.hasTestDestination = void 0;
// Whether "send test copy" can go anywhere for this vendor — the same
// precondition VendorTestSendService enforces before touching a transport.
// Production vendors carry only live config until their test config is
// added, so the UI shows this instead of failing on click (user, 2026-09-20).
const hasTestDestination = (vendor) => Boolean(vendor.transport) && Boolean(vendor.testTransportConfig || vendor.testBuilderConfig);
exports.hasTestDestination = hasTestDestination;
// Vendor.allowedReportTypes (allow-list, fail-safe) and excludedReportTypes
// (deny-list) — a vendor with neither takes everything.
// A 手動配信 upload is the full-size PDF, never a Teaser, so a vendor limited
// to FLASH (Bloomberg) also takes a manual FULL (user, 2026-09-29).
const MANUAL_ALSO_ALLOWED = ['FULL'];
const acceptsReportType = (vendor, reportType, isManual = false) => (vendor.allowedReportTypes === undefined || vendor.allowedReportTypes.includes(reportType) || (isManual && MANUAL_ALSO_ALLOWED.includes(reportType))) &&
    !vendor.excludedReportTypes?.includes(reportType);
exports.acceptsReportType = acceptsReportType;
